export class GlobalEvent {

  public static sessionTimeout: string = 'sessionTimeout';
  public static sessionRefreshed: string = 'sessionRefreshed';
  public static sessionRefreshFailed: string = 'sessionRefreshFailed';

  public static requestFailedSessionTimeout: string = 'requestFailedSessionTimeout';
  public static requestFailedWrongToken: string = 'requestFailedWrongToken';

  public static userLogIn: string = 'userLogIn';
  public static workspaceSwitch: string = 'workspaceSwitch';
  public static userLogOut: string = 'userLogOut';
  public static showConnectBanner: string = 'showConnectBanner';
  public static hostedWebsiteFaster: string = 'hostedWebsiteFaster';
  public static hostedWebsitePages: string = 'hostedWebsitePages';
  public static customOffer: string = 'customOffer';
  public static websiteForSelected: string = 'websiteForSelected';
  public static hideOnboardingBackButton: string = 'hideOnboardingBackButton';
  public static connectWebsite: string = 'connectWebsite';
  public static showDemoPreviewIframe: string = 'showDemoPreviewIframe';
  public static userInstanceCreating: string = 'userInstanceCreating';
  public static ecommerceModeChange: string = 'ecommerceModeChange';

}
